import { trackEvent } from '../components/analytics/analytics'
import { TRACK_EVENTS } from '../constants'

// Segment: the top bar's Regional Intel entry was chosen (icon row or ☰ menu), with the platform stamp
// only. It runs on the click that
// opens the link, so a blocked Segment script (no window.analytics) must never break it: errors are
// swallowed, like the LAYI notifications switch does (chatbot/chatbotTracking.js).
export const trackRegionalIntelClicked = () => {
  try {
    trackEvent(TRACK_EVENTS.TOP_BAR_REGIONAL_INTEL_CLICKED, { platform: 'web' })
  } catch (error) {
    // Analytics unavailable: the link still opens.
  }
}
